module.exports = __webpack_public_path__ + "static/pulsio_box_opened-defdb1b3d48b4a9fc13288c224f21977.png";